import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { FooterDisclosure } from "./AIDisclosure";
import { POLICY_GROUPS, POLICIES } from "../../data/legal";

const navCol = [
  { to: "/", label: "Home" },
  { to: "/authoriteos", label: "AuthorityOS" },
  { to: "/portfolio", label: "The Labs" },
  { to: "/log", label: "Builder's Log" },
  { to: "/work", label: "Work With Us" },
  { to: "/build", label: "Build" },
  { to: "/build-plus-content-engine", label: "Build + Content Engine" },
  { to: "/score", label: "Score" },
  { to: "/shop", label: "Shop" },
  { to: "/resources", label: "Free Resources" },
  { to: "/contact", label: "Contact" },
];

const portfolioCol = [
  "MetabolicLabOS",
  "BeaconsIEP",
  "Build Ready",
  "AASC",
  "ChalkOS",
  "Kaiya Solutions",
];

// Flatten policy groups into one "Legal" column for the footer
const legalCol = POLICY_GROUPS.flatMap((g) => g.items).map((slug) => ({
  to: `/legal/${slug}`,
  label: POLICIES[slug].title,
}));

const ColLabel = ({ children }) => (
  <div style={{ color: "#fff", fontSize: 9, textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700, marginBottom: 12 }}>
    {children}
  </div>
);

export const Footer = () => (
  <footer
    data-testid="footer"
    style={{
      background: "#060606",
      borderTop: "1px solid #111",
      padding: "32px 32px 20px",
    }}
  >
    <div
      style={{
        maxWidth: 1200,
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1.4fr 1fr 1fr 1.2fr",
        gap: 32,
      }}
      className="tag-footer-grid"
    >
      <div>
        <div style={{ marginBottom: 12 }} data-testid="footer-admin-link">
          <Logo to="/admin" />
        </div>
        <div style={{ color: "#fff", fontSize: 13, marginBottom: 12 }}>Help expertise win again.</div>
        <div style={{ color: "#fff", opacity: 0.6, fontSize: 11 }}>© The Authority Gap 2024</div>
      </div>

      <div>
        <ColLabel>Navigation</ColLabel>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {navCol.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              style={{ color: "#fff", fontSize: 11 }}
              data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s/g, "")}`}
            >
              {n.label}
            </Link>
          ))}
        </div>
      </div>

      <div>
        <ColLabel>Portfolio</ColLabel>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {portfolioCol.map((n) => (
            <span key={n} style={{ color: "#fff", fontSize: 11 }}>{n}</span>
          ))}
        </div>
      </div>

      <div>
        <ColLabel>Legal &amp; Disclosure</ColLabel>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {legalCol.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-legal-${l.to.split("/").pop()}`}
              style={{ color: "#fff", fontSize: 11 }}
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </div>

    <div
      style={{
        maxWidth: 1200,
        margin: "20px auto 0",
        borderTop: "1px solid #111",
        paddingTop: 16,
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 10,
      }}
    >
      <span style={{ color: "#fff", opacity: 0.5, fontSize: 10 }}>theauthoritygap.co</span>
      <span style={{ color: "#fff", opacity: 0.5, fontSize: 10 }}>Built with AuthorityOS</span>
    </div>

    <FooterDisclosure />

    <style>{`
      @media (max-width: 880px) {
        .tag-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 24px !important; }
      }
      @media (max-width: 560px) {
        .tag-footer-grid { grid-template-columns: 1fr !important; }
      }
    `}</style>
  </footer>
);
